export default __webpack_public_path__ + "static/media/ea-img.c0a73ba0.webp";